import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

import Title from "../../components/LandingPage/Title";
import Button from "@mui/material/Button";
import useStyles from "../../components/CardPaper/cardStyle-jss";

function ContactDetails(props) {
  const { classes, cx } = useStyles();
  const { title, price, feature, tier } = props;

  const getTier = (lv) => {
    switch (lv) {
      case "cheap":
        return classes.cheap;
      case "expensive":
        return classes.expensive;
      case "more-expensive":
        return classes.moreExpensive;
      default:
        return classes.free;
    }
  };

  return (
    <Card
      //  className={cx(classes.priceCard, getTier(tier))}
      className={classes.contactDetailsCard}
    >
      <CardContent className={classes.featureList}>
        <Title title="Contact" align="left" nomargin />
        <div className={classes.addressBox}>
          <div className={classes.flexBox}>
            <i className="ion-ios-mail"></i>
            support-ivp[at]cdac[dot]in
          </div>
          <div className={classes.flexBox}>
            <i className="ion-md-call"></i>
            +91-9100034446/7/8
          </div>
          <div className={classes.flexBox}>
            <i className="ion-md-pin"></i>
            Centre of Development of Advanced Computing Plot No. 6 & 7,Sy No.1/1
            Srisailam Highway Pahadi Shareef,Via Keshavagiri Post Hyderabad,
            Telangana Pin Code: 501510
          </div>
        </div>
      </CardContent>
      {/* <CardActions className={classes.btnArea}></CardActions> */}
    </Card>
  );
}

ContactDetails.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  tier: PropTypes.string.isRequired,
  feature: PropTypes.array.isRequired,
};

export default ContactDetails;
